import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isValidCompetenceDate } from './is-valid-competence-date.util';

export const formCompetenceDateValidator = (control: AbstractControl): ValidationErrors | null => {
  const isValid: boolean = control.value ? isValidCompetenceDate(control.value) : true;

  if (isValid) {
    return null;
  }

  return {
    isValidCompetenceDate: false
  };
};
